module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container gallery-container",
    attrs: {
      "id": "gallery-container"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n    Gallery\n  ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "masonry",
      rawName: "v-masonry"
    }, {
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "masonry-container",
    attrs: {
      "id": "masonry-container",
      "transition-duration": "0.0s",
      "item-selector": ".masonry-item",
      "data-masonry-options": "{ 'isFitWidth': true }",
      "infinite-scroll-disabled": "itemsLoading",
      "infinite-scroll-distance": "10"
    }
  }, _vm._l((_vm.items), function(image, index) {
    return _c('div', {
      directives: [{
        name: "masonry-tile",
        rawName: "v-masonry-tile"
      }],
      staticClass: "masonry-item",
      attrs: {
        "data-aos": "slide-up",
        "data-aos-once": "true",
        "data-aos-duration": "1000",
        "data-aos-offset": "0"
      }
    }, [_c('a', {
      attrs: {
        "href": image.link,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-image"
    }, [_c('figure', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": _vm.parseInstagramImageLink(image.images.standard_resolution.url),
        "alt": "Image"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "media"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "media-content"
    }, [_c('p', {
      staticClass: "title is-4"
    }, [_vm._v(_vm._s(image.id))]), _vm._v(" "), _c('p', {
      staticClass: "title is-4"
    }, [_vm._v(_vm._s(image.link))]), _vm._v(" "), _c('p', {
      staticClass: "title is-4"
    }, [_vm._v(_vm._s(image.caption.text))])])]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_vm._v("\n              " + _vm._s(image.description) + " "), _c('a', [_vm._v("@architecture")]), _vm._v(".\n              "), _c('a', [_vm._v("#elegant")]), _vm._v(" "), _c('a', [_vm._v("#design")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm._f("datetime")(image.created_at)))])])])])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "load-more"
  }, [(!_vm.itemsEnded) ? _c('div', {
    staticClass: "button",
    class: {
      'is-loading': _vm.itemsLoading
    },
    on: {
      "click": function($event) {
        _vm.loadMore()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.itemsEnded) ? _c('div', {
    staticClass: "ended",
    attrs: {
      "data-aos": "slide-up",
      "data-aos-once": "true",
      "data-aos-duration": "1000"
    }
  }, [_vm._v("browse more at"), _c('br', {
    staticClass: "is-hidden-desktop"
  }), _vm._v("  "), _vm._m(1)]) : _vm._e()]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "control notification is-danger"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.error = undefined
      }
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.error)
    }
  })]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-left"
  }, [_c('figure', {
    staticClass: "image is-48x48"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "30px"
    },
    attrs: {
      "src": "http://bulma.io/images/placeholders/96x96.png",
      "alt": "Image"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://www.instagram.com/adamlob0/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-instagram",
    staticStyle: {
      "vertical-align": "middle"
    }
  }), _vm._v(" / ADAMLOBOTV")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d88073e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MasonryInstagram.vue
// module id = 804
// module chunks = 1